import { useState } from "react";
import { Routes, Route, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import AdminProducts from "./AdminProducts";
import AdminReviews from "./AdminReviews";
import AdminBanners from "./AdminBanners";
import AdminVideo from "./AdminVideo";
import AdminOrders from "./AdminOrders";
import AdminCategories from "./AdminCategories";
import AdminProductTypes from "./AdminProductTypes";
import ChangePasswordModal from "./ChangePasswordModal";
import AdminCertificates from "./AdminCertificates";
import AdminContacts from "./AdminContacts";
import "./AdminPage.css";

const NAV = [
  { path: "", label: "📦 Товари", end: true },
  { path: "categories", label: "🏷️ Категорії" },
  { path: "product-types", label: "🗂️ Типи товарів" },
  { path: "reviews", label: "⭐ Відгуки" },
  { path: "certificates", label: "🎁 Сертифікати" },
  { path: "banners", label: "🖼️ Банери" },
  { path: "video", label: "🎬 Відео" },
  { path: "orders", label: "🛒 Замовлення" },
  {
    path: "contacts",
    label: "📩 Повідомлення",
  },
];

export default function AdminPage() {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { admin, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/admin/login", { replace: true });
  };

  return (
    <div className="admin-layout">
      <aside className={`admin-sidebar ${sidebarOpen ? "open" : "collapsed"}`}>
        <div className="admin-sidebar-header">
          <div className="admin-logo">
            <span>✿</span>
            {sidebarOpen && <span>Адмін-панель</span>}
          </div>
          <button className="sidebar-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
            {sidebarOpen ? "‹" : "›"}
          </button>
        </div>

        <nav className="admin-nav">
          {NAV.map((item) => (
            <NavLink
              key={item.path}
              to={`/admin${item.path ? "/" + item.path : ""}`}
              end={item.end}
              className={({ isActive }) => `admin-nav-item ${isActive ? "active" : ""}`}
            >
              <span className="nav-icon">{item.label.split(" ")[0]}</span>
              {sidebarOpen && <span>{item.label.split(" ").slice(1).join(" ")}</span>}
            </NavLink>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          <div className={`admin-user-block ${sidebarOpen ? "expanded" : ""}`}>
            <div className="admin-user-avatar">
              {admin?.username?.charAt(0).toUpperCase() || "A"}
            </div>
            {sidebarOpen && (
              <>
                <div className="admin-user-info">
                  <span className="admin-user-name">{admin?.username}</span>
                  <span className="admin-user-role">Адміністратор</span>
                </div>
                <div className="admin-user-menu-wrap">
                  <button
                    className="admin-user-menu-btn"
                    onClick={() => setUserMenuOpen((v) => !v)}
                  >
                    ⋯
                  </button>
                  {userMenuOpen && (
                    <div className="admin-user-dropdown">
                      <button
                        onClick={() => {
                          setShowPasswordModal(true);
                          setUserMenuOpen(false);
                        }}
                      >
                        🔑 Змінити пароль
                      </button>
                      <button
                        onClick={() => {
                          navigate("/");
                          setUserMenuOpen(false);
                        }}
                      >
                        🌐 На сайт
                      </button>
                      <div className="dropdown-divider" />
                      <button className="logout-item" onClick={handleLogout}>
                        🚪 Вийти
                      </button>
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
          {!sidebarOpen && (
            <button className="admin-back-btn" onClick={handleLogout} title="Вийти">
              <span>🚪</span>
            </button>
          )}
        </div>
      </aside>

      <main className="admin-main">
        <div className="admin-topbar">
          <div className="admin-topbar-left">
            <span className="admin-breadcrumb">zori.place</span>
            <span className="admin-breadcrumb-sep">›</span>
            <span className="admin-breadcrumb active">Адмін-панель</span>
          </div>
          <div className="admin-topbar-right">
            <button className="topbar-btn" onClick={() => navigate("/")}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
              </svg>
              <span>На сайт</span>
            </button>
            <button className="topbar-btn" onClick={() => setShowPasswordModal(true)}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0110 0v4" />
              </svg>
            </button>
            <button className="topbar-btn topbar-logout" onClick={handleLogout}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
                <polyline points="16 17 21 12 16 7" />
                <line x1="21" y1="12" x2="9" y2="12" />
              </svg>
              <span>Вийти</span>
            </button>
          </div>
        </div>

        <div className="admin-content">
          <Routes>
            <Route path="/" element={<AdminProducts />} />
            <Route path="/categories" element={<AdminCategories />} />
            <Route path="/product-types" element={<AdminProductTypes />} />
            <Route path="/reviews" element={<AdminReviews />} />
            <Route path="/certificates" element={<AdminCertificates />} />
            <Route path="/banners" element={<AdminBanners />} />
            <Route path="/video" element={<AdminVideo />} />
            <Route path="/orders" element={<AdminOrders />} />
            <Route path="/contacts" element={<AdminContacts />} />
          </Routes>
        </div>
      </main>

      {showPasswordModal && <ChangePasswordModal onClose={() => setShowPasswordModal(false)} />}
    </div>
  );
}
